<template>
  <div class="saldo-value-container">
    <div class="saldo-value" :class="{ blink: blink }">
      <p>
        <span>{{ saldo ? saldo.currency : $root.currency }}</span>
        {{ saldo ? saldo.base : $root.saldoDisplay.base }}
      </p>
      <span class="cents">.{{ saldo ? saldo.decimal : $root.saldoDisplay.decimal }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SaldoValue',
  props: {
    saldo: Object
  },
  data () {
    return {
      blink: false
    }
  },
  watch: {
    saldo () {
      this.blink = true

      setTimeout(() => {
        this.blink = false
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
  .blink {
    animation: blink .3s linear forwards;
    animation-delay: .5s;
  }

  @keyframes blink {
    0% {
      transform: scale(1);
      opacity: 1;
    }

    50% {
      transform: scale(1.2);
      opacity: 0.0;
    }

    100% {
      transform: scale(1);
      opacity: 1;
    }
  }

  .saldo-value-container {
    @include breakpoint (xs) {
      // background-color: white;
      // height: 200px;
      // width: 200px;
      // display: flex;
      // justify-content: center;
      // align-items: center;
      // border-radius: 2000px;
      // box-sizing: border-box;
    }
  }

  .saldo-value {
    position: relative;

    p {
      text-align: right;
      color: $main;
      span {
        color: #C0C4CC;
        font-weight: 300;
      }
      margin: 0;
      margin-right: 20px;
      font-size: 24px;

      @include breakpoint (xs) {
        font-size: 18px;
        font-weight: 600;
        color: white;

        span {
          color: rgba(white, .6);
        }
      }
    }

    span.cents {
      font-size: 14px;
      color: #C0C4CC;
      position: absolute;
      bottom: 3.5px;
      right: 0px;

      @include breakpoint (xs) {
        color: rgba(white, .6);
        bottom: 1px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/SaldoValue.vue